import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { adminAPI } from '../lib/api';
import { useAuth } from '../context/AuthContext';

const FullscreenSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="animate-spin rounded-full h-8 w-8 border-2 border-black border-t-transparent"></div>
  </div>
);

const isAbortLike = (err) =>
  err.name === 'AbortError' ||
  err.name === 'CanceledError' ||
  err.code === 'ERR_CANCELED' ||
  String(err.message || '').toLowerCase().includes('aborted');

export default function AdminRoute({ children }) {
  const { isAuthenticated, loading, token } = useAuth();
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (loading || !isAuthenticated) {
      setChecking(false);
      setAllowed(false);
      return;
    }
    const controller = new AbortController();
    let active = true;
    adminAPI
      .me({ signal: controller.signal })
      .then(() => {
        if (!active) return;
        setAllowed(true);
      })
      .catch((err) => {
        if (!active || isAbortLike(err)) return;
        setAllowed(false);
      })
      .finally(() => {
        if (!active || controller.signal.aborted) return;
        setChecking(false);
      });
    return () => {
      active = false;
      controller.abort();
    };
  }, [loading, isAuthenticated]);

  if ((!token && !isAuthenticated) || (loading && !isAuthenticated)) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  if (loading || checking) return <FullscreenSpinner />;
  if (!isAuthenticated) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (!allowed) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  return children;
}
